import React, { FC } from "react";
import {
  FormControl,
  Grid,
  InputAdornment,
  Link,
  Modal,
  OutlinedInput,
  Radio,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import SearchIcon from "@mui/icons-material/Search";
import { formatToUsDate } from "../utils/DateHelper";

interface Props {
  patientsCount: string;
  programs: any[];
  currentProgram: any;
  selectedProgram: any;
  setSelectedProgram: any;
  showTransferToProgramModal: boolean;
  setShowTransferToProgramModal: any;
  handleConfirmTransfer: any;
}

const ChooseProgramModal: FC<Props> = ({
  patientsCount,
  programs,
  currentProgram,
  selectedProgram,
  setSelectedProgram,
  showTransferToProgramModal,
  setShowTransferToProgramModal,
  handleConfirmTransfer,
}) => {
  const [searchKey, setSearchKey] = React.useState<string>(undefined);

  const filteredPrograms = programs?.filter((program) => {
    if (!searchKey) return true;
    const key = searchKey.toLowerCase();
    return (
      program.title?.toLowerCase().includes(key) ||
      program.subtext?.toLowerCase().includes(key)
    );
  });

  return (
    <Modal open={showTransferToProgramModal} className="follow-up-modal">
      <div className="paper" style={{ width: "900px", padding: "0px" }}>
        <div className="paperInner" style={{ padding: "0px" }}>
          <Grid
            container
            className="fum-header-container"
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <h1 className="fum-header">Transfer Patients from Program</h1>
            <Link
              onClick={() => setShowTransferToProgramModal(false)}
              style={{ color: "black", paddingRight: "20px" }}
            >
              <CloseIcon />
            </Link>
          </Grid>
          <div className="divider-orange" style={{ margin: "0px" }}></div>

          <Grid
            container
            style={{ padding: "24px" }}
            alignItems={"center"}
            spacing={4}
          >
            <Grid item xs={12} md={12} className="subdued-text">
              You are about to transfer <b>{patientsCount} patient(s)</b> from{" "}
              {currentProgram?.title} to{" "}
              {selectedProgram?.title || "a new program"}. This action cannot be
              undone. Patients will no longer be enrolled in this program.
              Please select a new program
            </Grid>
            <Grid
              item
              xs={12}
              md={5}
              style={{
                position: "relative",
                marginLeft: "0px !important",
              }}
            >
              <FormControl sx={{ width: "100%" }} variant="outlined">
                <OutlinedInput
                  id="outlined-adornment-weight"
                  placeholder="Search Programs"
                  endAdornment={
                    <InputAdornment position="end">
                      <SearchIcon />
                    </InputAdornment>
                  }
                  style={{ backgroundColor: "#EFE9E7", border: "none" }}
                  value={searchKey}
                  onChange={(event) => {
                    setSearchKey(event.target.value);
                  }}
                />
              </FormControl>
            </Grid>
          </Grid>

          <TableContainer
            className="template-container"
            sx={{ maxHeight: "50vh" }}
          >
            <Table className="no-border-table">
              <TableHead sx={{ borderBottom: "1.5px solid black" }}>
                <TableRow>
                  <TableCell width={"1%"} />
                  <TableCell
                    className="bold-font-face nowrap-header"
                    style={{ cursor: "pointer" }}
                    sx={{ pl: "0" }}
                  >
                    <strong>Program Name</strong>
                  </TableCell>
                  <TableCell>
                    <strong>Subtext</strong>
                  </TableCell>
                  <TableCell>
                    <strong>Publish Date</strong>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {filteredPrograms?.map((program) => (
                  <TableRow key={program?.id}>
                    <TableCell
                      width={"1%"}
                      align="right"
                      sx={{ pr: 0, pl: "24px" }}
                    >
                      <Radio
                        checked={selectedProgram?.id === program?.id}
                        value={program.id}
                        onChange={() => setSelectedProgram(program)}
                      />
                    </TableCell>
                    <TableCell sx={{ pl: "0" }}>{program.title}</TableCell>
                    <TableCell>{program.subtext}</TableCell>
                    <TableCell>
                      {program.published_at
                        ? formatToUsDate(program.published_at)
                        : "N/A"}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>

          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
            style={{ padding: "30px" }}
          >
            <Grid
              item
              xs={4}
              className="cancel-link-container"
              style={{ display: "flex", justifyContent: "center" }}
            >
              <Link
                className="cancel-link"
                onClick={() => setShowTransferToProgramModal(false)}
              >
                Cancel
              </Link>
            </Grid>
            <Grid item xs={4} className="confirm-btn-container">
              <Link
                onClick={handleConfirmTransfer}
                className="confirm-btn"
                style={{ width: "135px" }}
              >
                Transfer
              </Link>
            </Grid>
          </Grid>
        </div>
      </div>
    </Modal>
  );
};

export default ChooseProgramModal;
